<template>
  <div class="kpi-box">
    <div class="kpi-label">
      <slot name="label" />
        </div>
    <div class="kpi-content">
      <a
        v-if="showCloseButton"
        @click="$emit('closeKpiBox', 'test')"
        class="close-button"
      >
        &times;
      </a>
      <slot name="content" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'campaign-kpi-box',
  props: {
    showCloseButton: false
  },
}
</script>

<style scoped>
  .kpi-box {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 5px 15px;
    width: 250px;
    height: 160px;
    border: 2px solid #a6d4fc;
    border-radius: 16px;
    margin: 5px 10px;
    text-align: center;
    font-family: AileronLight,sans-serif;
  }

  .close-button{
    position:absolute;
    top:5px;
    left:5px;
    font-size:1em;
    line-height: 1em;
    width:1em;
    color:#128ff9;
    user-select: none;
  }

  @media only screen and (max-width: 1023px) {
    .kpi-box {
      margin: 5px 10px 5px 0;
      padding: 5px 10px;
    }
  }
</style>
